import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import {
  CredentialRepresentation,
  getCredentials,
  useEnvironment,
} from '@keycloak/keycloak-account-ui';
import { Box, Typography } from '@mui/material';

import { Button } from '@/ui/Button';

import { formatDate } from './utils/date';
import { px2rem } from './utils/px2rem';

export default function ManagePassword() {
  const { t } = useTranslation('passwordForm');
  const context = useEnvironment();
  const [credential, setCredential] = useState<
    CredentialRepresentation | undefined
  >();
  const [updateAction, setUpdateAction] = useState('');

  useEffect(() => {
    getCredentials({ context }).then((credentials) => {
      const passwordData = credentials.find(
        (credential) => credential.type === 'password',
      );
      const passwordMetadata = passwordData?.userCredentialMetadatas.find(
        (item) => item.credential.type === 'password',
      );

      if (passwordData?.updateAction) {
        setUpdateAction(passwordData.updateAction);
      }

      if (passwordMetadata?.credential) {
        setCredential(passwordMetadata?.credential);
      }
    });
  }, []);

  return (
    <>
      <Typography
        fontWeight={{ xs: 800, sm: 400 }}
        fontSize={{ xs: 24, sm: 36 }}
        variant="h4"
      >
        {t('title')}
      </Typography>
      <Typography mt={8} mb={3} sx={{ fontSize: px2rem(14) }} color="secondary">
        {t('subtitle')}
      </Typography>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '12px 16px',
          backgroundColor: (theme) => theme.palette.background.default,
          borderRadius: 3,
          minHeight: 72,
          flexDirection: { xs: 'column', sm: 'row' },
        }}
      >
        {credential?.createdDate ? (
          <Typography>
            {t('createdAt')} <b>{formatDate(credential.createdDate)}</b>
          </Typography>
        ) : null}
        <Button
          variant="outlined"
          color="primary"
          onClick={() => {
            context.keycloak.login({
              action: updateAction || 'UPDATE_PASSWORD',
            });
          }}
          sx={{ width: { xs: '100%', sm: 125 }, marginTop: { xs: 4, sm: 0 } }}
        >
          {t('submitButton')}
        </Button>
      </Box>
    </>
  );
}
